import React from 'react';
import './CarLoan.css';
import 'animate.css/animate.min.css';
import Seo from "../components/Seo";





function CarLoan() {
  return (
    <>

      <Seo
        title="Best Car Loan Offers & Interest Rates 2025 - Mortbuzz"
        description="Compare the best car loan offers in 2025 with low interest rates, flexible EMI plans, and instant approval. Find top banks and NBFC deals with Mortbuzz."
        keywords="car loan 2025, best car loan offers, car loan interest rates, vehicle loan, auto loan, EMI calculator"
        canonical="https://www.mortbuzz.in/car-loan"
      />
   



        {/* <!-- Hero Section -->*/}
        <section className="mortbuzzcarheroCar d-flex flex-column justify-content-center">
        <div className="overlay position-absolute top-0 start-0 w-100 h-100"></div>
        <div className="container">
        <h1 className="animate__animated animate__fadeInDown">Drive Your Dream Car Home – MortBuzz Makes It Easy</h1>
        <p className="lead animate__animated animate__fadeInUp animate__delay-1s">Find the best Car loan solutions tailored for you. Apply for car Loan Online,with low interest car loan in pune</p>
        <a href="apply-now" class="apply-btn-glass mt-4 animate__animated animate__fadeInUp animate__delay-2s 
            text-decoration-none">Apply Now</a>
    </div>
</section>



{/*<!-- About Home Loan -->*/}
<section className="section bg-dark">
    <div className="container">
        <div className="row align-items-center">
            <div className="col-lg-6 mb-4">
                <img src="/images/Bank Pages/night-drive-supercar-scaled.jpg" className="img-fluid rounded shadow animate__animated animate__fadeInLeft" alt="Dream House"/>
            </div>
            <div className="col-lg-6">
                <h2 className="mb-4 text-white">🚗 Why Choose MortBuzz for Your Car Loan In Pune?</h2>
                <p className="text-white">A car loan is a secured loan that helps you buy your dream car without straining your savings. Whether you're purchasing a brand-new vehicle or a pre-owned one, MortBuzz ensures a smooth and affordable financing experience. With minimal documentation, flexible repayment options, and quick approval, your car ownership journey starts with ease.so that why we are the best car loan provider in pune.

From first-time buyers to seasoned drivers upgrading their ride – MortBuzz Car Loans are designed to put you in the driver’s seat faster.</p>
                <ul className="list-unstyled mt-3 text-white">
                    <li>🚘 Attractive Interest Rates Starting at Just 7.60% p.a.*</li>
                    <li>💰 Finance Up to 100% of On-Road Price</li>
                    <li>⏱️ Quick Approvals Within 48 Hours</li>
                    <li>📑 Minimal Documentation Required</li>
                    <li>🔄 Flexible Repayment Tenure Up to 7 Years</li>
                    <li>🏠 Doorstep Service for Application & Documents</li>
                    <li>💸 Zero Hidden Charges & Transparent Process</li>
                </ul>
            </div>
        </div>
    </div>
</section>






{/*<!-- Loan Uses -->*/}
<section className="section bg-light">
    <div className="container text-center">
        <h2 className="mb-5">🚗 Uses of a instant Car Loan approval</h2>
        <div className="row g-4">
            <div className="col-md-4">
                <div className="mortbuzzcarcard p-4 animate__animated animate__zoomIn">
                    <h5>New Car Purchase</h5>
                    <p>Buy your dream car with easy and affordable EMIs.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="mortbuzzcarcard p-4 animate__animated animate__zoomIn animate__delay-1s">
                    <h5>Used Car Purchase</h5>
                    <p>Own a well-maintained pre-owned car with flexible financing options.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="mortbuzzcarcard p-4 animate__animated animate__zoomIn animate__delay-2s">
                    <h5>Car Loan Balance Transfer</h5>
                    <p>Reduce your EMI burden by transferring your existing car loan to MortBuzz at lower interest rates.</p>
                </div>
            </div>
        </div>
    </div>
</section>

{/*<!-- Eligibility Criteria -->*/}
<section className="section bg-dark">
    <div className="container">
        <h2 className="text-center mb-5 text-white">Car Loan in Pune Eligibility Criteria</h2>
        <div className="row text-center">
            {/* CARD 1 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/salaried-image-icon.png" 
                        alt="Eligibility" 
                        style={{ width: '200px', height: '200px' }}
                        className="mb-3"
                    />
                    <p className="text-center">Salaried/Working Professional</p>
                </div>
            </div>
            {/* CARD 2 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/age.png" 
                        alt="Age" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3" 
                    />
                    <p className="text-center">Age: 21-60 Years</p>
                </div>
            </div>
            {/* CARD 3 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/3-month-experienced.png" 
                        alt="Experience" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3"
                    />
                    <p className="text-center">Having a job and a minimum of<br />3 months experience</p>
                </div>
            </div>
            {/* CARD 4 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/minimum-income_20000.png" 
                        alt="Income" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3"
                    />
                    <p className="text-center">Having a minimum of Rs. 25,000<br />net income per month.</p>
                </div>
            </div>
        </div>
    </div>
</section>



{/*<!-- Apply Section -->*/}
<section id="apply" className="section bg-light text-center">
    <div className="container">
        <h2 className="mb-4">Ready to Start Your Journey? Apply For Car Loan Online</h2>
        <p>Apply now and let MortBuzz Solutions Advisory guide you to the best Car loan options.</p>
        <a href="apply-now" className="apply-btn-glass btn-lg mt-3 text-decoration-none">Apply for Home Loan</a>
    </div>
</section>


{/*<!-- Documentation Required Section -->*/}
<section className="section bg-dark">
    <div className="container">
        <h2 className="text-center mb-5 text-white">Documentation Required for Car Loan</h2>
        <div className="row g-5">

           {/* <!-- Photo Identity Proof -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInLeft bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        
                        <img src="/images/Bank Pages/photo-identy.png" alt="Photo-ID" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-primary">Photo Identity Proof For Car Loan</h5>
                    </div>
                    <ul className="text-white">
                        <li>Voter ID</li>
                        <li>Aadhaar Card</li>
                        <li>Passport</li>
                        <li>PAN Card</li>
                        <li>Driving Licence</li>
                    </ul>
                </div>
            </div>

            {/*<!-- Proof of Residence -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInRight bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/proof-of-residence.png" alt="Address Proof" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Proof of Residence for Car Loan</h5>
                    </div>
                    <ul className="text-white">
                        <li>Aadhaar Card</li>
                        <li>Driving Licence</li>
                        <li>Passport</li>
                        <li>Registered Rent Agreement</li>
                        <li>Latest Gas/Electricity Bill</li>
                        <li>Bank Statement with Current Address</li>
                    </ul>
                </div>
            </div>

            {/*<!-- Income Proof -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInLeft bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/income-proof.png" alt="Income Proof" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Income Proof For Car Loan</h5>
                    </div>
                    <ul className="text-white">
                        <li>Income Tax Returns (Last 3 Years)</li>
                        <li>Business License Details</li>
                        <li>Audited Balance Sheet & Profit/Loss (Last 3 Years)</li>
                        <li>Business Address Proof</li>
                        <li>6-Month Bank Statements (Current & Savings)</li>
                        <li>Copy of Form 16</li>
                        <li>6-Month Salary Account Statements</li>
                        <li>Last 3 Months’ Salary Slips</li>
                    </ul>
                </div>
            </div>

         {/*   <!-- Other Documents -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInRight bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/other-document.png" alt="Other Documents" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Other Documents For Car Loan</h5>
                    </div>  
                    <ul className="text-white">
                        <li>Allotment Letter</li>
                        <li>Sale Deed</li>
                        <li>No Objection Certificate (NOC)</li>
                        <li>Allotment Letter from Society/Housing Board/Builder</li>
                        <li>Stamped Agreement of Sale</li>
                        <li>Possession Certificate</li>
                        <li>Construction Cost Estimate</li>
                        <li>Bank Payment Statement</li>
                        <li>Occupancy Certificate</li>
                        <li>Land Tax Receipt</li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</section>





{/*<!-- Application Process Section -->*/}
<section className="section bg-dark py-5">
    <div className="container">
      <h2 className="text-center mb-5 text-white">Application Process To apply for car loan online</h2>
  
      <div className="timeline">
        {/*<!-- Step 1 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 1: Connect with Us</h4>
            <p className="text-white">Explain your needs. We curate car loan products most suitable for your profile.</p>
          </div>
        </div>
  
       {/* <!-- Step 2 -->*/}
        <div className="timeline-container right">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 2: Compare Loan Products</h4>
            <p className="text-white">We help you compare several car loan products so you can choose the best one.</p>
          </div>
        </div>
  
        {/*<!-- Step 3 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 3: Apply Online</h4>
            <p className="text-white">Pick a lender, apply online, and submit all necessary paperwork with our assistance.</p>
          </div>
        </div>
  
   {/*     <!-- Step 4 -->*/}
        <div className="timeline-container right">
          <div className="content bg-dark border border-primary">
            <h4 className="text-white">Step 4: Application Processing</h4>
            <p className="text-white">The lender verifies your documentation and processes the application.</p>
          </div>
        </div>
  
    {/*    <!-- Step 5 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 5: Receive Funds</h4>
            <p className="text-white">Upon approval, the loan amount is credited directly to your account.</p>
          </div>
        </div>
  
      </div>
    </div>
  </section>





  {/* <!-- Home Loan Rates Section -->*/}
<section className="section bg-light py-5">
    <div className="container">
      <h2 className="text-center mb-5">low interest car loan in pune</h2>
  
      <div className="table-responsive">
        <table className="table table-hover table-striped shadow-lg rounded">
          <thead className="table-primary">
            <tr>
              <th>Bank Name</th>
              <th>Min. Rate of Interest (%)</th>
              <th>Loan Amount</th>
              <th>Loan Tenure</th>
              <th>Processing Fees</th>
              <th>Apply Now</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><a href="https://bankofindia.co.in/vehicle-loan1">Bank Of India</a></td>
              <td>8.75%</td>
              <td>Upto 70 LAKHS</td>
              <td>3 years - 7 years</td>
              <td>0.25% </td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://bankofmaharashtra.in/personal-banking/loans/car-loan">Bank Of Maharashtra</a></td>
              <td>7.70% p.a*</td>
              <td>upto 50 LAKH</td>
              <td>3 years - 8 years</td>
              <td>1.00%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.centralbankofindia.co.in/en/node/418">Central Bank Of India</a></td>
              <td>7.60%</td>
              <td>Loan Amount more than Rs.25 lakh</td>
              <td>84 Month</td>
              <td> 0.50%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.iob.in/Vehicle-loans">Indian overseas Bank</a></td>
              <td>8.35%</td>
              <td>Rs. 10 LAKHS - 10CR</td>
              <td>maxiumum of 84 months</td>
              <td>0.50%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>
  </section>


 <section className="section py-5 bg-dark">
    <div className="container">
      <div className="row align-items-center g-5">
        {/*<!-- Image Section -->*/}
        <div className="col-md-6 text-center">
          <img src="/images/FrontPage/loan-dealing.jpg" alt="Processing Fee" className="img-fluid rounded shadow"/>
        </div>
  
        {/*<!-- Content Section -->*/}
        <div className="col-md-6">
          <h2 className="mb-4 text-white" style={{fontWeight: '700'}}>Processing Fee</h2>
          <p style={{fontSize: '17px', color:' #ffff'}}>
            Besides the <strong>📄 Car Loan Processing Fee – What You Need to Know</strong>In addition to the interest rate, lenders charge a processing fee when you apply for a car loan. This fee covers administrative costs such as document verification, credit checks, and loan disbursement.
          </p>
          <p style={{fontSize: '17px', color:' #fff'}}>
            Typically, the processing fee for car loans ranges from<strong> 0.25% to 1%</strong> of the total loan amount. Some banks and NBFCs may charge a flat fee (e.g., ₹2,500 to ₹6,000), especially for used car loans. A <strong>GST of 18%</strong> is applicable on the fee.
          </p>
          <p style={{fontSize: '17px', color: '#fff'}}>
            At <strong> With MortBuzz Solutions Advisory:</strong>, We connect you with lenders offering minimal or zero processing fees <span style={{color: '#007bff'}}>Enjoy transparent charges and zero hidden costs</span> Maximize your savings from day one
          </p>
          .
          <a href="apply-now" className="apply-btn-glass mt-3">Get Best Offers</a>
        </div>
      </div>
    </div>
  </section>










  <section
  className="emi-section py-5"
  style={{ background: 'linear-gradient(135deg, #e0f7fa, #ffffff)' }}
>

    <div className="container">
      <div className="row align-items-center g-5">
        {/*<!-- Content Section -->*/}
        <div className="col-md-6">
          <h2 className="mb-4" style={{fontWeight: 800, color: '#004d7a'}}>EMI Calculator</h2>
          <p style={{fontSize: '18px', color: '#333'}}>
            Before you apply for a home loan, it's essential to ensure you can conveniently repay the EMIs.
            Manual calculations might seem easy but aren't always accurate.
          </p>
          <p style={{fontSize: '18px', color: '#333'}}>
            Use <strong>MortBuzz Solutions Home Loan Calculator</strong> online to get
            <span style={{color: '#007bff'}}>instant and accurate EMI estimations</span> within seconds.
            Just input your <strong>Loan Amount</strong>, <strong>Interest Rate</strong>, and <strong>Loan Tenure</strong> to discover your monthly repayment obligation.
          </p>
  
          <a href="https://app.mortbuzz.in/Mortbuzz-emi-calculater.html" className="apply-btn-glass mt-4">Try EMI Calculator</a>
        </div>
  
      {/*  <!-- Image or Animation Section --> */}
        <div className="col-md-6 text-center">
          <img src="/images/FrontPage/calculate.jpg" alt="EMI Calculator" className="img-fluid rounded shadow-lg" style={{maxWidth: '400px'}}/>
        </div>
      </div>
    </div>
  </section>




  {/*<!-- mortbuzz Additionally adding Text Box Section -->*/}

<section className="section bg-dark">
    <div className="container">
        <div className="row align-items-center">
            <div className="col-lg-6 mb-4">
                <img src="/images/Bank Pages/carloan.png" className="img-fluid rounded shadow animate__animated animate__fadeInLeft" alt="Dream House"/>
            </div>
            <div className="col-lg-6">
                <h2 className="mb-4 text-white">🚗 MortBuzz Solutions Car Loan in pune Balance Transfer</h2>
                <p className="text-white">If you're currently repaying a car loan at a high interest rate, it's time to reduce your EMI burden with a Car Loan Balance Transfer. This facility allows you to shift your outstanding loan from your existing lender to a new one offering better terms — such as lower interest rates, flexible repayment options, and reduced monthly EMIs.

Through MortBuzz, you can enjoy a seamless balance transfer process while unlocking additional benefits like top-up loans and zero hidden charges.</p>
                <ul className="list-unstyled mt-3 text-white">
                    <li>✅ Why Choose MortBuzz for Your Car Loan in pune Balance Transfer?</li>
                    <li>🚘 Lower Interest Rates Starting from 8.25% p.a.*</li>
                    <li>🔄 Flexible Repayment Tenure up to 7 Years</li>
                    <li>💸 Reduced EMIs with Transparent Charges</li>
                    <li>📞 360-Degree Loan Assistance</li>
                    <li>🧾 Minimal Paperwork & Fast Processing</li>
                    <li>🏠 Doorstep Document Collection</li>
                </ul>
            </div>
        </div>
    </div>
</section>

{/*<!-- mortbuzz Additionally adding Text Box Section End -->*/}









    
    </>
  );
}

export default CarLoan;